import React from 'react';
import IndustryCard from './IndustryCard';
// import industriesData from "../../data/expirience/industries.json";
import styled from 'styled-components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FlexContainer = styled.div`
    width:100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; 
  gap: 2rem; 
  padding: 0 2rem; 
  margin: 2rem auto;
`;

const Industries = () => {
  const { t } = useTranslation('experience');
  const industriesData = t('industries', { returnObjects: true });
  const industryItems = industriesData.filter((i) => i?.type === 'industry');
  const otherItems = industriesData.filter((i) => i?.type !== 'industry');
  return (
    <>
    <Typography variant='h2' sx={{my:5}}>
      {t('industrySectors')}
    </Typography>
    <Typography>
      {t('industrySectorsDescription')}
    </Typography>
    <Box sx={{ mt: 4 }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        {t('industryCategoryIndustry')}
      </Typography>
      <FlexContainer>
        {industryItems.map((item, index) => (
          <IndustryCard key={`industry-${index}`} src={item.image} industryName={item.name} />
        ))}
      </FlexContainer>
    </Box>

    <Box sx={{ mt: 4 }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        {t('industryCategoryOther')}
      </Typography>
      <FlexContainer>
        {otherItems.map((item, index) => (
          <IndustryCard key={`other-${index}`} src={item.image} industryName={item.name} />
        ))}
      </FlexContainer>
    </Box>
    </>
  );
}

export default Industries;
